export default __webpack_public_path__ + "static/media/crLogo.748344fe.png";